import { Button, Flex, Menu } from '@mantine/core';
import { IconChevronDown } from '@tabler/icons-react';
import usePageSizeDropdown from '../../helpers/usePageSizeDropdown';
import ReactPaginate from '../react-paginate';

const Pager = ({ pageSize, pageCount, onPageChange, initialPage, setPageSize }) => {
  const pageSizeDropdown = usePageSizeDropdown(pageSize, setPageSize);

  if (pageCount === 1) {
    return;
  }

  return (
    <Flex justify="flex-end" align="flex-start" gap="md" mb="md" wrap="wrap">
      {pageCount > 1 && (
        <Menu position="bottom-end">
          <Menu.Target>
            <Button size="sm" rightSection={<IconChevronDown size={14} />}>
              Page Size: {pageSize}
            </Button>
          </Menu.Target>
          <Menu.Dropdown>{pageSizeDropdown}</Menu.Dropdown>
        </Menu>
      )}
      <ReactPaginate
        previousLabel="&nbsp;&nbsp;<&nbsp;&nbsp;"
        nextLabel="&nbsp;&nbsp;>&nbsp;&nbsp;"
        breakLabel="..."
        pageCount={pageCount}
        marginPagesDisplayed={2}
        pageRangeDisplayed={5}
        onPageChange={onPageChange}
        initialPage={initialPage}
      />
    </Flex>
  );
};
export default Pager;
